import { Scene } from "phaser";

import { GButton } from "../gameobjects/GButton";
import { combinations } from '../utils';

// The HUD scene is the scene that shows the points and the remaining time.
export class ManualPickSceneDesktop extends Scene {
    
    constructor() {
        super("ManualPickSceneDesktop");

    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
        //console.log('init', data);
        const { min, max, ticketPrice, minNumber, maxNumber } = data;
        this.minPickNumber = min
        this.maxPickNumber = max
        this.totalPicked = 0;
        
        this.ticketValue = ticketPrice
        this.totalAmount = this.totalPicked < this.minPickNumber?0:parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue).toFixed(2);
        this.currency = "$"    
        this.minNumber = minNumber;
        this.maxNumber = maxNumber;
        this.SelectedNumberArray =  [];
        this.ButtonArray =  [];

    }

    create() {
        // Load and blur the background image
        this.backgroundImage = this.add.image(0, 0, 'lotto-bg');
        this.backgroundImage.setOrigin(0, 0);
        this.backgroundImage.setScale(
            this.scale.width / this.backgroundImage.width,
            this.scale.height / this.backgroundImage.height
        );

        // Create the mask graphics
        this.backgroundGraphics = this.add.graphics();
        this.backgroundGraphics.fillStyle(0xaaaaaa, 0.1);
        this.backgroundGraphics.fillRoundedRect(
            this.scale.width/2-450, 
            this.scale.height/2-200, 
            900, 
            400, 
            { tl: 15, tr: 15, bl: 15, br: 15 }
        );

        // Apply the mask to the background image
        this.backgroundImage.setMask(new Phaser.Display.Masks.GeometryMask(this, this.backgroundGraphics));

        // Add blur effect
        this.backgroundImage.preFX.addBlur(1, 2, 2, 2, 0xffffff, 4);
        // this.backgroundImage.setPipeline('BlurPipeline');
        // this.backgroundImage.pipeline.setFloat('blur', 5); // Adjust blur intensity as needed

        const HeaderY = 62

        this.numberGrid = [];
        this.title = this.add.text(this.scale.width/2, HeaderY , `ADD TICKET`,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')

        const ButtonBack = new GButton(this,this.scale.width/2-360, HeaderY, {
            texturePack: "pack", 
            text: {
                value: 'BACK',
                style:  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }
            },
            icon: {
                image: 'arrow back_ios.png',
                scale: 0.4,
                align: 'left',
                x: -30
            },
            // idleTexture: 'arrow back_ios.png',
            // clickedTexture: 'arrow back_ios.png',
            // disabledTexture: 'arrow back_ios.png',
            onClick: () => {
                //console.log('Button ButtonBack!');
                this.scene.start("BuyTicketSceneDesktop");
             }
        });


        
        const BoxWidth = 356 * 2
        const BoxHight = 410 *2 
        const containerY = (62  +16 + 28 +24) *2;

        


        this.boxGraphics = this.add.graphics();

        this.boxGraphics.fillStyle(0x05022D, 1);
    
      
        //  Using an object to define a different radius per corner
        this.boxGraphics.fillRoundedRect(-64, 22, BoxWidth,BoxHight, { tl: 32, tr: 32, bl: 32, br: 32 });

        // (62  +16 + 28 +24) =2
        this.numberSelectedTextStyle =  { fontFamily: 'Oswald', fontSize: 30, color: '#ffffff' };
        this.numberSelectedText = this.add.text(360,  150 , `MANUAL PICK`,  this.numberSelectedTextStyle).setOrigin(0.5,0);
        this.numberSelectedText.setFontStyle("700")


        const valueTextStyle = { fontSize: 16, fontFamily: 'Montserrat', color: '#fff', fontWeight:500 };


        this.SelectedNumbers = this.add.nineslice(360, 280, 'pack', 'Slider-Base.png', 280*2, 104, 32, 32);

        this.SelectedNumbers.setScale(0.5)

        this.SelectedNumbersValue = this.add.text(360, 280 , `${this.SelectedNumberArray.length}`,   { fontSize: 20, fontFamily: 'Montserrat', color: '#fff', fontWeight:700 }).setOrigin(0.5)

        this.SelectedNumberText = this.add.text(360, 280 - 50, `Numbers Selected:`,  valueTextStyle).setOrigin(0.5)
        

        // Create the Price Information 

        this.TotalPrice = this.add.nineslice(360, 400, 'pack', 'Slider-Base.png', 280*2, 104, 32, 32);

        this.TotalPrice.setScale(0.5)

       

        //this.valueText = scene.add.text(bounds.width + bounds.x - 32, bounds.y+50, `$1,135.60`,  valueTextStyle).setOrigin(1,0.5)
        this.valueText = this.add.text(360, 400 , `${this.currency}${this.totalAmount}`,   { fontSize: 20, fontFamily: 'Montserrat', color: '#fff', fontWeight:700 }).setOrigin(0.5)


        this.ticketCost = this.add.text(360, 400 - 50, `Ticket Cost:`,  valueTextStyle).setOrigin(0.5)



        this.ButtonClear = new GButton(this, this.scale.width/2 - 90, this.scale.height -48, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            text: {
                value:'CLEAR',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                
                this.ButtonArray.forEach((object, index) => {
                    object.enable();
                    if (this.SelectedNumberArray.includes(index+1)) {
                        object.setSelected()
                    }
                });
                this.SelectedNumberArray.length = 0;
                this.ButtonConfirm.setDisabled()
                this.ButtonClear.setDisabled()
                this.calculateTicketPrice();
                this.SelectedNumbersValue.setText( `${this.SelectedNumberArray.length}`)
                
             }
        });

        this.ButtonClear.setScale(0.5);

        this.ButtonClear.setDisabled()


        this.ButtonConfirm = new GButton(this,  this.scale.width/2 + 90, this.scale.height -48, {
            texturePack: "pack", 
            idleTexture: 'Button - Primary - Default.png',
            clickedTexture: 'Button - Primary - Clicked.png',
            disabledTexture: 'Button - Primary - Disabled.png',
            text: {
                value:'CONFIRM',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                this.confirmSelection();
            }
        });

        this.ButtonConfirm.setScale(0.5);

        this.ButtonConfirm.setDisabled()



        // Define container dimensions
        let containerWidth = 200;
        let containerHeight = 150;

        // let containerX = this.scale.width/2-286;
        // let containerY = 300;

        // if(!window.isMobile){
        //     containerWidth = 200*2
        //     containerHeight = 150*2
        //     containerX = this.scale.width/2-286*2
        //     containerY = 300*2
        // }

        // Create a container and set its position in the scene
        this.myContainer = this.add.container(this.scale.width/2+ 100, this.scale.height/2 - 196);
        this.myContainer.setScale(0.45);

        this.myContainer.add(this.boxGraphics)

        // Create a red border around the container using a Graphics object
        // const border = this.add.graphics();
        // border.lineStyle(2, 0xff0000); // 2px width, red color
        // border.strokeRect(
        //     -containerWidth / 2, // Offset x position to center the border around the container
        //     -containerHeight / 2, // Offset y position to center the border around the container
        //     containerWidth,
        //     containerHeight
        // );

        // // Add the border to the container
        // this.myContainer.add(border);

        //console.log(this)
        this.createGrid();
       

    }



     // Method to create and display the grid of numbers as text objects
     createGrid() {
        const columns = 7;       // Number of columns
        const textSpacingX = (40 + 8)*2 ; // Horizontal space between text objects
        const textSpacingY = (40 + 16)*2; // Vertical space between text objects
        //console.log(this)
        for (let i  = 0 ; i < this.maxNumber; i++) {

            //console.log(i,this.minNumber , this.maxNumber)
            //const number = this.numbersArray[i];
            const number = i+1;

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX ;
            const y = Math.floor(i / columns) * textSpacingY + 48 +50;//+290 +50

            // Create the text object for the current number

            
          //  const numberCircle = this.add.sprite(x, y, 'pack' ,'Lotto Number - Unselected - Default.png');

            const numberCircle = new GButton(this, x, y, {
                texturePack: "pack", 
                idleTexture: 'Lotto Number - Unselected - Default.png',
                clickedTexture: 'Lotto Number - Selected - Clicked.png',
                disabledTexture: 'Lotto Number - Disabled.png',
                selectedTexture: 'Lotto Number - Selected - Default.png',
                text: {
                    value: number.toString(),
                    style:  {
                        fontFamily: 'Montserrat',
                        fontSize: '30px',
                        color: '#fff',
                    },
                    styleDisabled:  {
                        fontFamily: 'Montserrat',
                        fontSize: '30px',
                        color: '#757B8C',
                    },
                    styleSelected:  {
                        fontFamily: 'Montserrat',
                        fontSize: '30px',
                        color: '#232323',
                    },

                },
                onClick: () => {
                    numberCircle.setSelected()
                    //console.log("Clear", i+1,  numberCircle.isSelected);
                    this.calculateSelection(i, numberCircle.isSelected)
                    this.buttonAvilability()
                    this.calculateTicketPrice();
                    this.SelectedNumbersValue.setText( `${this.SelectedNumberArray.length}`)
                    //this.numberSelectedText.setText( `${this.SelectedNumberArray.length} NUMBERS SELECTED`)
                    
                    //if( this.SelectedArray)
                }
            });

            this.myContainer.add(numberCircle)

            this.ButtonArray.push(numberCircle)

            // Add the text object to this container
            //this.scadd(numberCircle);
        }
        
    }


    confirmSelection(){
        const totalPrice = +this.registry.get('cart_amount') + +this.totalAmount;
        //console.log("totalPrice", totalPrice)
        this.registry.set('cart_amount', totalPrice);
        //console.log("after: this.registry.set('cart_amount', totalPrice);")
        const  selectedNumbers = this.SelectedNumberArray
        //console.log("selectedNumbers", selectedNumbers)
        let currentCatItem = this.registry.get('cart_items')
            currentCatItem.push({
            selectedNumbers: selectedNumbers,
            totalAmount: this.totalAmount,
            numberCount: this.SelectedNumberArray.length
        });

        //console.log("currentCatItem", currentCatItem)
        //console.log("currentCatItem",currentCatItem);
        this.registry.set('cart_items', currentCatItem);
        //console.log("After set items")

        this.scene.start("BuyTicketSceneDesktop");
        //this.scene.resume("BuyTicketScene")
    }

    buttonAvilability(){

        if(this.SelectedNumberArray.length == this.maxPickNumber){
                       
            // Loop through the array of objects
            this.ButtonArray.forEach((object, index) => {
                // Check if the current index is in the numbersArray
                if (!this.SelectedNumberArray.includes(index+1)) {
                    // Call the setDisabled() function if the index matches
                    object.setDisabled();
                }
            });
        }else if (this.SelectedNumberArray.length == this.maxPickNumber -1){
            
            this.ButtonArray.forEach((object, index) => {
                // Check if the current index is in the numbersArray
                if (!this.SelectedNumberArray.includes(index+1)) {
                    // Call the setDisabled() function if the index matches
                    object.enable();
                }
            });
        }

    }




    calculateTicketPrice(){

        
        //this.totalAmount = this.SelectedNumberArray.length < this.minPickNumber?0:parseFloat((this.SelectedNumberArray.length - this.minPickNumber +1 )*this.ticketValue).toFixed(2);
        this.totalAmount = this.SelectedNumberArray.length < this.minPickNumber?0:parseFloat(combinations(this.SelectedNumberArray.length, this.minPickNumber)*this.ticketValue).toFixed(2);
        this.valueText.setText(`${this.currency}${this.totalAmount}`);
        
    }

    calculateSelection(selectedNumber, isSelected) {


        if(isSelected){
            this.SelectedNumberArray.push(selectedNumber+1);
        }else{
            this.SelectedNumberArray = this.SelectedNumberArray.filter(number => number !== (selectedNumber+1))
        }

        this.SelectedNumberArray.sort((a, b) => a - b);

        if(this.SelectedNumberArray.length >=  this.minPickNumber){
            this.ButtonConfirm.enable()
        }else {
            this.ButtonConfirm.setDisabled();
        }

        if(this.SelectedNumberArray.length>=1){
            this.ButtonClear.enable()
        }else{
            this.ButtonClear.setDisabled();
        }

        //console.log("this.SelectedNumberArray", this.SelectedNumberArray)
    }

}